const NotFound = () => {
    return (
        <div className="Not-found-div">
            <h1 className="not-found-header text-align-center">404</h1>
            <p className="text-align-center">Page Not Found</p>
            <small className="text-align-center">Url not correct</small>
        </div>
    )
}
export default NotFound;